import forbidden from 'assets/img/forbidden@2x.png';
import { t } from 'utilities/TranslationUtils';

export const ForbiddenPage = () => {
  return (
    <article className='row d-flex align-items-center '>
      <header className='col-md-6'>
        <h1 className='font-42 font-500 text-uppercase '>{t('error.ForbiddenTitle')}</h1>
        <p className='font-22 '>{t('error.ForbiddenText')}</p>
      </header>
      <div className='col-md-6'>
        <img src={forbidden} alt='forbidden' width='700' />
      </div>
    </article>
  );
};

export default ForbiddenPage;
